import {combineReducers} from "redux";

import {IUserPreferencesStore, userPreferencesReducer} from "./user_preferences_reducer";

export interface IUserStore {
    preferences?: IUserPreferencesStore;
}

export const userReducer = combineReducers({
    preferences: userPreferencesReducer
});
